import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        loadingClass: { type: String, default: '[&_*]:transition-none' },
    }

    removeLoadingClass () {
        this.element.classList.remove(this.loadingClassValue)
    }
}
